import { CheckIcon } from '@heroicons/react/24/solid'

interface ComponentInterface {
  titles: string[]
  current: number
}

export default function StepsComponent({
  titles,
  current,
}: ComponentInterface) {
  return (
    <nav aria-label="Progress">
      <ol
        className={[
          'mb-2 divide-y divide-gray-300 rounded-md border border-gray-300',
          'md:flex md:divide-y-0',
        ].join(' ')}
        role="list"
      >
        {titles.map((step, stepIdx) => (
          <li className="relative md:flex md:flex-1" key={stepIdx}>
            {current > stepIdx ? (
              <div className="group flex w-full items-center">
                <span className="flex items-center px-6 py-4 text-sm font-medium">
                  <span
                    className={[
                      'flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full',
                      'bg-slate-700 group-hover:bg-slate-800',
                    ].join(' ')}
                  >
                    <CheckIcon
                      aria-hidden="true"
                      className="h-6 w-6 text-white"
                    />
                  </span>
                  <span className="ml-4 text-sm font-medium text-gray-900">
                    {step}
                  </span>
                </span>
              </div>
            ) : current === stepIdx ? (
              <div
                aria-current="step"
                className="flex items-center px-6 py-4 text-sm font-medium"
              >
                <span
                  className={[
                    'flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full',
                    'border-2 border-slate-700',
                  ].join(' ')}
                >
                  <span className="text-slate-700">{`${stepIdx + 1}`}</span>
                </span>
                <span className="ml-4 text-sm font-medium text-slate-700">
                  {step}
                </span>
              </div>
            ) : (
              <div className="group flex items-center">
                <span className="flex items-center px-6 py-4 text-sm font-medium">
                  <span
                    className={[
                      'flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full',
                      'border-2 border-gray-300 group-hover:border-gray-400',
                    ].join(' ')}
                  >
                    <span className="text-gray-500 group-hover:text-gray-900">{`${stepIdx + 1}`}</span>
                  </span>
                  <span className="ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900">
                    {step}
                  </span>
                </span>
              </div>
            )}

            {stepIdx !== titles.length - 1 ? (
              <>
                {/* Arrow separator for lg screens and up */}
                <div
                  aria-hidden="true"
                  className="absolute right-0 top-0 hidden h-full w-5 md:block"
                >
                  <svg
                    className="h-full w-full text-gray-300"
                    fill="none"
                    preserveAspectRatio="none"
                    viewBox="0 0 22 80"
                  >
                    <path
                      d="M0 -2L20 40L0 82"
                      stroke="currentcolor"
                      strokeLinejoin="round"
                      vectorEffect="non-scaling-stroke"
                    />
                  </svg>
                </div>
              </>
            ) : null}
          </li>
        ))}
      </ol>
    </nav>
  )
}
